import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";
function NaoVendi() {
  const [cpf, setCpf] = useState('');
  const [sku, setSku] = useState('');
  const [produtoSearch, setProdutoSearch] = useState('');
  const [sugestoes, setSugestoes] = useState([]);
  const [dataHora, setDataHora] = useState('');
  const [loja, setLoja] = useState('');
  const [valor, setValor] = useState('');
  const [motivos, setMotivos] = useState(['Estoque']); // Já começa marcado com "Estoque"
  const [precoConcorrente, setPrecoConcorrente] = useState('');

  const navigate = useNavigate();
  const matriculaSession = sessionStorage.getItem("matricula");
  const matricula = matriculaSession ? JSON.parse(matriculaSession).username : null;
  useEffect(() => {
  
    const now = new Date();
    const offset = now.getTimezoneOffset();
    const localDate = new Date(now.getTime() - offset * 60000);
    setDataHora(localDate.toISOString().slice(0, 16));
    
  }, []);
  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/");
  };
  const buscarSugestoes = async (texto) => {
    try {
      const res = await axios.get(`https://fsys.app.br/5dx/buscar_produtos.php?q=${encodeURIComponent(texto)}`);
      setSugestoes(res.data);
    } catch (error) {
      console.error("Erro ao buscar sugestões:", error);
    }
  };

  const handleProdutoChange = (e) => {
    const value = e.target.value;
    setProdutoSearch(value);
    setSku('');
    setValor('');
    if (value.length >= 2) {
      buscarSugestoes(value);
    } else {
      setSugestoes([]);
    }
  };

  const handleSelecionarProduto = (produto) => {
    setProdutoSearch(produto.nome);
    setSku(produto.codigo);
    setValor(produto.valorVenda || '');
    setSugestoes([]);
  };
  const toggleMotivo = (motivo) => {
    setMotivos((prev) =>
      prev.includes(motivo)
        ? prev.filter((m) => m !== motivo)
        : [...prev, motivo]
    );
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Recupera a matrícula da sessionStorage
  const matriculaSession = sessionStorage.getItem("matricula");
  const matricula = matriculaSession ? JSON.parse(matriculaSession).username : null;
    const formData = {
      cpf,
      sku,
      produto: produtoSearch,
      dataHora,
      loja,
      valor,
      motivos ,
      preco_concorrente: motivos.includes("Preço") ? precoConcorrente : null,
      matricula
    };

    try {
      const response = await axios.post('https://fsys.app.br/5dx/naovendi.php', formData);
      if (response.data.success) {
        Swal.fire({
          title: 'Sucesso!',
          text: response.data.message,
          icon: 'success',
          timer: 2000,
        showConfirmButton: false,
        });
        setCpf('');
        setSku('');
        setProdutoSearch('');
        setValor('');
        const now = new Date();
        const offset = now.getTimezoneOffset();
        const localDate = new Date(now.getTime() - offset * 60000);
        setDataHora(localDate.toISOString().slice(0, 16));
        setLoja('1');
        setMotivos('Estoque');
      } else {
        Swal.fire({
          title: 'Erro!',
          text: 'Houve um problema ao salvar os dados!',
          icon: 'error',
          confirmButtonText: 'Fechar'
        });
      }
    } catch (error) {
      console.error('Erro ao enviar dados para a API:', error);
    }
  };

  return (
    <div className="container">
       <h4 style={{position: 'fixed', top: 0, right: 16}}
       >Matricula: {matricula} - <button onClick={handleLogout} className="btn btn-sm btn-danger">sair</button></h4>
      <div className="row justify-content-center mt-5">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title text-center mb-4">Não Vendi</h4>
              <form onSubmit={handleSubmit}>
                {/* CPF */}
                {/* <div className="mb-3">
                  <label htmlFor="cpf" className="form-label">CPF do Cliente</label>
                  <input
                    type="text"
                    id="cpf"
                    className="form-control"
                    placeholder="Digite o CPF"
                    value={cpf}
                    onChange={(e) => setCpf(e.target.value)}
                    
                  />
                </div> */}

                {/* Produto com autocomplete */}
                <div className="mb-3 position-relative">
                  <label htmlFor="produto" className="form-label">Produto (ID ou Nome)</label>
                  <input
  type="text"
  id="produto"
  className="form-control"
  placeholder="Digite nome ou código do produto"
  value={produtoSearch}
  onChange={handleProdutoChange}
  onKeyDown={async (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (/^\d{8,14}$/.test(produtoSearch)) {
        try {
          const res = await axios.get(`https://fsys.app.br/5dx/buscar_produtos.php?q=${encodeURIComponent(produtoSearch)}`);
          if (res.data && res.data.length > 0) {
            handleSelecionarProduto(res.data[0]);
          } else {
            Swal.fire("Produto não encontrado", "", "warning");
          }
        } catch (error) {
          console.error("Erro ao buscar produto por código de barras:", error);
        }
      }
    }
  }}
  required
  autoComplete="off"
/>

                  {sugestoes.length > 0 && (
                    <ul className="list-group position-absolute w-100" style={{ zIndex: 1000 }}>
                      {sugestoes.map((item, index) => (
                        <li
                          key={index}
                          className="list-group-item list-group-item-action"
                          onClick={() => handleSelecionarProduto(item)}
                        >
                          {item.codigo} - {item.nome}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>

                {/* Valor */}
                <div className="mb-3">
                  <label htmlFor="valor" className="form-label">Valor do Produto</label>
                  <input
                    type="number"
                    id="valor"
                    className="form-control"
                    value={valor}
                    onChange={(e) => setValor(e.target.value)}
                    required
                    min="0"
                    step="0.01"
                    disabled
                  />
                </div>
                <div className="mb-3" style={{
    display: 'flex'
}}>
  <label className="form-label">Motivos: </label>
  <div className="form-check">
    <input
      className="form-check-input"
      type="checkbox"
      id="motivo-estoque"
      checked={motivos.includes("Estoque")}
      onChange={() => toggleMotivo("Estoque")}
    />
    <label className="form-check-label" htmlFor="motivo-estoque">
      Estoque
    </label>
  </div>
  <div className="form-check">
    <input
      className="form-check-input"
      type="checkbox"
      id="motivo-preco"
      checked={motivos.includes("Preço")}
      onChange={() => toggleMotivo("Preço")}
    />
    <label className="form-check-label" htmlFor="motivo-preco">
      Preço
    </label>
    
  </div>
  <div className="form-check">
    <input
      className="form-check-input"
      type="checkbox"
      id="motivo-outros"
      checked={motivos.includes("Outros")}
      onChange={() => toggleMotivo("Outros")}
    />
    <label className="form-check-label" htmlFor="motivo-outros">
      Outros
    </label>
  </div>
</div>
                {/* Data e Hora */}
                {motivos.includes("Preço") && (
  <div className="mb-3">
    <label htmlFor="precoConcorrente" className="form-label">
      Qual era o preço no concorrente?
    </label>
    <input
      type="number"
      id="precoConcorrente"
      className="form-control"
      value={precoConcorrente}
      onChange={(e) => setPrecoConcorrente(e.target.value)}
      min="0"
      step="0.01"
      required
    />
  </div>
)}
                <div className="mb-3">
                  <label htmlFor="dataHora" className="form-label">Data e Hora</label>
                  <input
                    type="datetime-local"
                    id="dataHora"
                    className="form-control"
                    value={dataHora}
                    onChange={(e) => setDataHora(e.target.value)}
                    required
                  />
                </div>

                {/* Loja */}
                {/* <div className="mb-3">
                  <label htmlFor="loja" className="form-label">Loja</label>
                  <select
                    id="loja"
                    className="form-select"
                    value={loja}
                    onChange={(e) => setLoja(e.target.value)}
                    required
                  >
                    <option value="loja1">Loja 1</option>
                  </select>
                </div> */}


                {/* Submit */}
                <button type="submit" className="submit-button">Salvar</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NaoVendi;
